<app-breadcrumbs></app-breadcrumbs>
<div class="c-page-wrapper shop-page mt-sm-unset">

  <div class="container d-md-none mb-24-px pl-sm-unset pr-sm-unset">
    <app-mobile-part-catalog-menu [shop]="true" [collection$]="collection$"></app-mobile-part-catalog-menu>
  </div>

  <div class="container">

    <div class="d-none d-md-block">
      <app-parts-catalog-navigation-menu [collection$]="collection$"></app-parts-catalog-navigation-menu>
    </div>

    @if((collection && collection.populatable) || (!collection)){
    @if(initialLoading){
    <div class="pb-12-px pb-24-sm-px mb-20-px">
      <div class="mb-16-px">
        <p-skeleton width="100px" height="15px"></p-skeleton>
      </div>
      <p-skeleton width="100%" height="92px"></p-skeleton>
    </div>
    } @else {
    @if(filters?.top && filters?.top?.length > 0){
    <!--      <div class="d-none d-md-block">-->
    <div class="d-none d-md-block">
      <app-quick-filters [collection]="collection$ | async" [topFilters]="filters?.top"
        [activeQuickFilters]="activeQuickFilters$ | async" [loading$]="loading$"></app-quick-filters>
    </div>
    }
    }

    <div>
      <app-shop-navigation-block [collection]="collection$ | async" [leftFilters]="filters?.left"
        [activeLeftFilters]="activeLeftFilters$ | async" [totalResults]="totalResults" [initialLoading]="initialLoading"
        [loading$]="loading$" [perPage]="perPage" [page$]="page$" [sort]="sort$ | async" [loading]="loading$ | async"
        [searchTerm]="searchTerm$ | async" [topFilters]="filters?.top"
        [activeQuickFilters]="activeQuickFilters$ | async" [activeVehicle]="activeVehicle"></app-shop-navigation-block>
    </div>
    }
  </div>

  @if((collection && collection.populatable) || (!collection)){

  <div class="container pl-sm-unset pr-sm-unset">
    <div class="row mt-24-px mt-16-lg-px gx-custom-sm-unset">
      <div class="col-xl-3 col-lg-0 d-none d-xl-block">

        @if(initialLoading){
        <div>
          <p-skeleton width="100%" height="1000px"></p-skeleton>
        </div>
        } @else {

        @if((activeLeftFilters$ | async) && filters?.left){
        <app-shop-filters [collection]="collection$ | async" [leftFilters]="filters?.left"
          [activeLeftFilters]="activeLeftFilters$ | async" [totalResults]="unfilteredTotalItems"
          [initialLoading]="initialLoading" [loading$]="loading$"></app-shop-filters>
        }
        }
      </div>
      <div class="col-xl-9 col-lg-12">
        @if(initialLoading){
        <div>
          <p-skeleton width="260px" height="20px"></p-skeleton>
        </div>
        } @else {
        <div class="paginator-label pl-12-sm-px pr-12-sm-px">
          @if (!notFoundProducts) {
          <span>
            Showing: {{ (page$ | async) * perPage + 1 }} -
            {{ totalResults < ((page$ | async) + 1) * perPage ? totalResults :
            ((page$ | async) + 1) * perPage }} out of
            {{totalResults}}
            @if(searchTerm){ search results for <b>"{{searchTerm}}"</b>}
            @if(collection?.name){ in <b>"{{collection?.name}}"</b> category}
            @if(activeVehicle){ for your <b> {{activeVehicle.year}} {{activeVehicle.details?.manufacturer?.name}}
              {{activeVehicle.details?.model?.name}} {{activeVehicle.details?.modification?.name}}</b>}

          </span>
          } @else {
          @if(!initialLoading && !loading){
          <span class="not-found-text">
            Sorry, no results were found
            @if(searchTerm){for <b>"{{searchTerm}}"</b>}
            @if(collection?.name){in <b>"{{collection?.name}}"</b> category}
            @if(activeVehicle){ for your <b> {{activeVehicle.year}} {{activeVehicle.details?.manufacturer?.name}}
              {{activeVehicle.details?.model?.name}} {{activeVehicle.details?.modification?.name}}</b>}
          </span>
          }

          }
        </div>
        }
        @if((loading$ | async) || initialLoading){
        <div>
          @for(skeleton of productsSkeletonArray; track skeleton.id){
          <div class="mt-16-px mb-16-px">
            <div class="grid-item">
              <p-skeleton width="100%" [height]="'216px'"></p-skeleton>
            </div>

          </div>
          }
        </div>

        } @else {
        @if (products && products.length > 0) {
        <app-shop-items [searchResults]="products" [showSaveAction]="true"></app-shop-items>
        }
        }
        @if(initialLoading){
        <div>
          <p-skeleton width="315px" height="40px"></p-skeleton>
        </div>
        } @else {
        <div class="mt-24-px mt-32-md-px">
          <app-pagination [loading]="loading$ | async" [first]="(page$ | async) * perPage" [perPage]="perPage"
            [currentPage]="page$ | async" [totalResults]="totalResults" [collection]="collection$ | async"
            [searchTerm]="searchTerm" [inShop]="true" [activeVehicle]="activeVehicle$ | async" [showLabel]="true">
          </app-pagination>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>

<app-page-description [fatherPageDescriptionEnabled]="true">
  @if(!collection){
  <a class="link no-underline grey weight-500" [routerLink]="'/'+vehicleTypeService?.currentVehicleType"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>Fastparts
      shop</b></a> is your go-to destination for top-quality automotive parts
  and
  auto car replacement parts including oils,
  tires, rims, and batteries
  for all types of vehicles.
  Discover {{totalResults}} top-quality parts at <a class="link no-underline grey weight-500"
    [routerLink]="'/'+vehicleTypeService?.currentVehicleType"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>Fastparts
      shop</b></a>.
  Our extensive selection ensures you find the perfect <a class="link no-underline grey weight-500"
    [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop', collection?.breadcrumbs?.[1]?.slug]"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>{{collection?.breadcrumbs?.[1]?.name}}</b></a>
  for
  any vehicle, including BMW, Ford, Honda, Toyota, Mercedes-Benz, Chevrolet,
  Nissan, Volkswagen, Audi, and
  Hyundai.<br /><br />
  @if(searchTerm){
  Search results for "<a class="link no-underline grey weight-500"
    [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop','search']"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"
    [queryParams]="{search: searchTerm}"><b>{{searchTerm}}</b></a>" include a
  wide range of products designed to deliver
  performance and
  reliability.
  }
  @if(totalResults > 10){
  With {{totalResults}} items found, you're sure to find exactly what you're
  looking for.
  }
  Trust <a class="link no-underline grey weight-500" [routerLink]="'/'+vehicleTypeService?.currentVehicleType"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>Fastparts shop</b></a> to
  provide the best
  parts and
  accessories, ensuring your
  vehicle is always in top condition and
  enjoy fast shipping, expert advice, and hassle-free returns on all orders.
  } @else {
  Discover {{totalResults}} top-quality @if(collection){ <a class="link no-underline grey weight-500"
    [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop', collection?.breadcrumbs?.[1]?.slug]"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>{{collection?.breadcrumbs?.[1]?.name}}</b></a>
  }
  @if(collection?.breadcrumbs?.length > 2){ within <a class="link no-underline grey weight-500"
    [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop','category', collection?.slug]"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>{{collection?.name}}</b></a>
  category} at <a class="link no-underline grey weight-500" [routerLink]="'/'+vehicleTypeService?.currentVehicleType"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>Fastparts shop</b></a>.
  <a class="link no-underline grey weight-500" [routerLink]="'/'+vehicleTypeService?.currentVehicleType"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>Fastparts
      shop</b></a>
  is your go-to destination for top-quality automotive parts and auto car
  replacement parts including oils, tires, rims,
  and batteries
  for all types of vehicles.
  Our extensive selection ensures you find the perfect <a class="link no-underline grey weight-500"
    [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop', collection?.breadcrumbs?.[1]?.slug]"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>{{collection?.breadcrumbs?.[1]?.name}}</b></a>
  for
  any vehicle, including BMW, Ford, Honda, Toyota, Mercedes-Benz, Chevrolet,
  Nissan, Volkswagen, Audi, and Hyundai.
  Whether you're looking for products in the <a class="link no-underline grey weight-500"
    [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop','category', collection?.slug]"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>{{collection?.name}}</b></a>
  category or something more
  specific, we've got you
  covered.<br /><br />
  @if(searchTerm){
  Search results for "<a class="link no-underline grey weight-500"
    [routerLink]="['/',vehicleTypeService?.currentVehicleType,'shop','search']"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"
    [queryParams]="{search: searchTerm}"><b>{{searchTerm}}</b></a>" include a
  wide range of products designed to deliver
  performance and
  reliability.
  }
  @if(totalResults > 10){
  With {{totalResults}} items found, you're sure to find exactly what you're
  looking for.
  }
  Trust <a class="link no-underline grey weight-500" [routerLink]="'/'+vehicleTypeService?.currentVehicleType"
    [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }"><b>Fastparts shop</b></a> to
  provide the best
  parts and
  accessories, ensuring your
  vehicle is always in top condition and
  enjoy fast shipping, expert advice, and hassle-free returns on all orders.
  }

</app-page-description>
<p-scrollTop />
